export default __webpack_public_path__ + "static/media/LoginPageBackground.a77b1bf8.webp";